const Meta = ({
  title,
  description,
  image,
}: {
  title?: string;
  description?: string;
  image?: string;
}) => {
  const baseTitle = import.meta.env.VITE_APP_NAME;

  return (
    <>
      <title>{title ? `${title} | ${baseTitle}` : baseTitle}</title>
      <meta
        name="description"
        content={description || import.meta.env.VITE_APP_DESCRIPTION}
      />
      <meta property="og:title" content={title || baseTitle} />
      <meta
        property="og:description"
        content={description || import.meta.env.VITE_APP_DESCRIPTION}
      />
      {image && <meta property="og:image" content={image} />}
    </>
  );
};

export default Meta;
